import { ActionType } from "../interfaces/api/actionType";

export const GetExperienceYears: ActionType = {
  FAILURE: "GET_EXPERIENCE_YEARS_FAILURE",
  REQUEST: "GET_EXPERIENCE_YEARS_REQUEST",
  SUCCESS: "GET_EXPERIENCE_YEARS_SUCCESS",
};
